import { render, staticRenderFns } from "./AutomationTemplatesLayout.vue?vue&type=template&id=6e4d9414&scoped=true&"
import script from "./AutomationTemplatesLayout.vue?vue&type=script&lang=js&"
export * from "./AutomationTemplatesLayout.vue?vue&type=script&lang=js&"
import style0 from "./AutomationTemplatesLayout.vue?vue&type=style&index=0&id=6e4d9414&prod&lang=scss&"
import style1 from "./AutomationTemplatesLayout.vue?vue&type=style&index=1&id=6e4d9414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d9414",
  null
  
)

export default component.exports